import Body from "../../components/UI/Body";
import { Hero } from "../../components/UI/Hero";
import { GetStarted } from "../../components/UI/GetStarted";
import ApiSession from "../../components/UI/ApiDocs";

export const Home = () => {
  return (
    <>
      <Hero />
      <Body />
      <GetStarted />
      <ApiSession />
    </>
  );
};
